module.exports = __webpack_public_path__ + "media/images/premium/premium-logo-8481f5d81aed5a667f2da383e99244d7.svg";